/**
 * Opções da imagem de divulgação (o "mockup").
 *
 * A ideia é vender o miolo: uma foto da agenda **aberta**, com a espiral à mostra,
 * sobre um fundo, para o cliente publicar em rede social ou mandar no WhatsApp. É
 * um **segundo desenho** do produto — não sai no PDF, não entra na configuração do
 * miolo e não muda nada do que já existe ([[Impressão e PDF]]).
 *
 * Aqui ficam só os **nomes e as medidas**: o desenho é do site
 * (`apps/web/src/mockup/`), e quem vira arquivo é o Chromium do servidor, igual ao
 * PDF. Estar no core é o que faz o assistente, a página do mockup e a API falarem
 * das mesmas opções — e o que permite testá-las sem navegador.
 */
/** Os dois destinos mais usados em rede social. */
export const FORMATOS_MOCKUP = ['QUADRADO', 'STORIES'];
export const MEDIDAS_MOCKUP = {
    QUADRADO: { larguraPx: 1080, alturaPx: 1080, rotulo: 'Quadrado (1:1)' },
    STORIES: { larguraPx: 1080, alturaPx: 1920, rotulo: 'Stories (9:16)' },
};
/** O que a pessoa usa como fundo atrás da agenda. */
export const FUNDOS_MOCKUP = ['MESA', 'LISA', 'DEGRADE', 'PAPEL', 'ESCURA'];
export const ROTULO_FUNDO_MOCKUP = {
    MESA: 'Mesa de madeira',
    LISA: 'Cor do tema',
    DEGRADE: 'Degradê do tema',
    PAPEL: 'Papel texturizado',
    ESCURA: 'Superfície escura',
};
export const DESCRICAO_FUNDO_MOCKUP = {
    MESA: 'Madeira quente, como foto de produto sobre a mesa.',
    LISA: 'A cor principal do miolo, chapada. A agenda fica sendo o assunto.',
    DEGRADE: 'Da cor principal para a de destaque — dá profundidade sem sujar a página.',
    PAPEL: 'Off-white com textura fina, para quem quer neutro e claro.',
    ESCURA: 'Grafite com um foco de luz atrás da agenda. Valoriza capa colorida.',
};
/** O que a foto mostra da agenda. */
export const CENAS_MOCKUP = ['CAPA_E_DIA', 'DOIS_DIAS'];
export const ROTULO_CENA_MOCKUP = {
    CAPA_E_DIA: 'Capa e um dia',
    DOIS_DIAS: 'Dois dias abertos',
};
export const DESCRICAO_CENA_MOCKUP = {
    CAPA_E_DIA: 'A capa à esquerda e uma página de dia à direita: mostra o acabamento e o miolo.',
    DOIS_DIAS: 'Duas páginas de dia: mostra a grade, os quadros e a pauta em uso.',
};
/** Quanto da largura da imagem a agenda ocupa, por formato. */
export const OCUPACAO_MOCKUP = {
    // No quadrado a agenda ocupa quase tudo; no stories sobra chão para a assinatura.
    QUADRADO: 0.9,
    STORIES: 0.88,
};
/** Tamanho máximo da assinatura — é uma linha, não um texto. */
export const MAXIMO_ASSINATURA_MOCKUP = 60;
export function opcoesMockupPadrao(assinatura = null) {
    return { formato: 'QUADRADO', fundo: 'MESA', cena: 'CAPA_E_DIA', assinatura };
}
/* ------------------------------------------------------------------ */
/* URL da página que o servidor fotografa                             */
/* ------------------------------------------------------------------ */
export const PARAMETROS_MOCKUP = {
    formato: 'formato',
    fundo: 'fundo',
    cena: 'cena',
    assinatura: 'assinatura',
};
/** A página desenhada para virar arquivo — quem abre é o Chromium do servidor. */
export function urlDaPaginaMockup(mioloId, passe, opcoes) {
    const parametros = new URLSearchParams({
        t: passe,
        [PARAMETROS_MOCKUP.formato]: opcoes.formato,
        [PARAMETROS_MOCKUP.fundo]: opcoes.fundo,
        [PARAMETROS_MOCKUP.cena]: opcoes.cena,
    });
    if (opcoes.assinatura)
        parametros.set(PARAMETROS_MOCKUP.assinatura, opcoes.assinatura);
    return `/mockup/${encodeURIComponent(mioloId)}?${parametros.toString()}`;
}
/** Lê as opções da URL, caindo no padrão quando o valor não existe. */
export function opcoesMockupDaUrl(consulta) {
    const escolher = (valores, valor, padrao) => valores.includes(valor) ? valor : padrao;
    const padrao = opcoesMockupPadrao();
    const assinatura = consulta.get(PARAMETROS_MOCKUP.assinatura)?.trim().slice(0, MAXIMO_ASSINATURA_MOCKUP);
    return {
        formato: escolher(FORMATOS_MOCKUP, consulta.get(PARAMETROS_MOCKUP.formato), padrao.formato),
        fundo: escolher(FUNDOS_MOCKUP, consulta.get(PARAMETROS_MOCKUP.fundo), padrao.fundo),
        cena: escolher(CENAS_MOCKUP, consulta.get(PARAMETROS_MOCKUP.cena), padrao.cena),
        assinatura: assinatura ? assinatura : null,
    };
}
//# sourceMappingURL=opcoes.js.map